import {useEffect} from 'react';

const useForcePageRefresh = () => {
  useEffect(() => {
    const handlePopState = () => {
      // Force a full page reload
      window.location.reload();
    };

    // Listen for popstate events
    window.addEventListener('popstate', handlePopState);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);
};

export default useForcePageRefresh;
